import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapState, mapGetters } from "vuex";
import { DELETE_REFERRER, LOAD_REFERRER, UPDATE_REFERRER, LOAD_REFERRER_CHANGELOG } from "../../store/referrer-actions";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import { REFERRER_LINKED_APPLICATIONS, REFERRER_LINKED_PROFILES } from "@Broker/@Modules/clients/referrers/store/referrer-getters.ts";
import { debounce } from "lodash";
import Amplitude from "@Shared/utils/amplitude";
import ReferrerDetailsHeader from "./referrer-details-header.vue";
import ReferrerDetails from "./referrer-details.vue";
import ReferrerCustomFields from "./referrer-custom-fields.vue";
import ReferrerActionsPanel from "./referrer-actions-panel.vue";
import ReferrerLinkedApps from "./referrer-linked-apps.vue";
import ReferrerLinkedProfiles from "./referrer-linked-profiles.vue";
import ReferrerTimelineContainer from "./referrer-timeline-container.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ReferrerDetailsContainer",
  components: {
    ReferrerCustomFields,
    ReferrerLinkedApps,
    ReferrerLinkedProfiles,
    ReferrerDetailsHeader,
    ReferrerDetails,
    ReferrerActionsPanel,
    ReferrerTimelineContainer
  },
  mixins: [validationMixin],
  // used directly because the referrer-details-form use them directly
  // in the v-model
  validations: {
    localReferrer: {
      familyName: {
        required
      },
      givenName: {
        required
      },
      type: {
        required
      },
      email: {
        email
      }
    }
  },
  props: {
    referrerId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      loading: true,
      localReferrer: {},
      saving: false,
      currentActionPanelTab: "note",
      timelineTab: "",
      loadingChangelog: false
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState("ReferrerStore", {
    referrer(state) {
      return state.referrers.byId[this.referrerId];
    }
  })), mapGetters("ReferrerStore", [REFERRER_LINKED_APPLICATIONS, REFERRER_LINKED_PROFILES])), {}, {
    applications() {
      return this.REFERRER_LINKED_APPLICATIONS(this.referrerId) || [];
    },
    profiles() {
      return this.REFERRER_LINKED_PROFILES(this.referrerId) || [];
    },
    invalid() {
      return this.$v.$invalid;
    }
  }),
  watch: {
    referrer(val) {
      this.$set(this, "localReferrer", val);
    },
    referrerId() {
      this.loadData();
    }
  },
  beforeMount() {
    this.loadData();
  },
  methods: _objectSpread(_objectSpread({}, mapActions("ReferrerStore", [LOAD_REFERRER, DELETE_REFERRER, UPDATE_REFERRER, LOAD_REFERRER_CHANGELOG])), {}, {
    async loadData() {
      try {
        this.loading = true;
        await this.LOAD_REFERRER({
          referrerId: this.referrerId
        });
      } catch (_unused) {
        this.navigateToRoot();
      } finally {
        this.loading = false;
      }
    },
    navigateToRoot() {
      this.$router.push({
        name: "referrers"
      });
    },
    handleSave: debounce(function (val) {
      this.fireSave(val);
    }, 500),
    async fireSave(val) {
      try {
        this.saving = true;
        this.localReferrer = val;
        if (!this.invalid) {
          await this.UPDATE_REFERRER({
            referrerId: this.referrerId,
            referrer: this.localReferrer
          });
        }
        if (this.timelineTab === "changelog") this.loadChangelog();
      } catch (e) {
        Amplitude.logHandledError(e);
      } finally {
        this.saving = false;
      }
    },
    async loadChangelog() {
      this.loadingChangelog = true;
      await this.LOAD_REFERRER_CHANGELOG({
        referrerId: this.referrerId
      });
      this.loadingChangelog = false;
    },
    changeActionPanelTab(action) {
      this.currentActionPanelTab = action;
    }
  })
});